import { LuMenu } from "react-icons/lu";
import { colors } from "../../design/tokens";
import {
  useIsSideMenuOpen,
  useSideMenuActions,
} from "../../view_stores/useSideMenuStore";

export function SideMenuIcon(): JSX.Element {
  const { open: openSideMenu, close: closeSideMenu } = useSideMenuActions();
  const isSideMenuOpen = useIsSideMenuOpen();

  function handleClick(e: React.MouseEvent): void {
    e.stopPropagation();
    if (isSideMenuOpen) {
      closeSideMenu();
    } else {
      openSideMenu();
    }
  }

  return (
    <button
      onClick={handleClick}
      className={`p-1 -m-1 cursor-pointer ${colors.text.primary} ${colors.hover.opacity} transition-opacity`}
      aria-label="Toggle menu"
    >
      <LuMenu size={34} />
    </button>
  );
}
